import { getAuthAxiosBackend } from "../../helpers/axios"

class EmployeeServices{

    get(id){
        return getAuthAxiosBackend().get('plots-of-land-2/employees/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('plots-of-land-2/employees', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('plots-of-land-2/employees/' + id)
    }
}

export default new EmployeeServices()